/*
 * V2 Search "Load More" (no build step).
 *
 * Fetches the next page of the v2-main-search section via Shopify section
 * rendering and appends the product cards. Appended <card-product> /
 * <product-purchase-options> / <variant-select-card> custom elements upgrade
 * automatically on insertion, so size + subscription controls work with no
 * re-initialisation.
 */
(function () {
  'use strict';

  var SECTION_ID = 'v2-main-search';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function init(root) {
    if (root.__v2SearchInit) return;
    root.__v2SearchInit = true;

    var button = root.querySelector('[data-v2-search-load-more]');
    var grid = root.querySelector('#product-grid');
    if (!button || !grid) return;

    var baseUrl = root.getAttribute('data-search-url');
    var current = parseInt(root.getAttribute('data-current-page'), 10) || 1;
    var total = parseInt(root.getAttribute('data-total-pages'), 10) || 1;
    var loading = false;

    if (current >= total) {
      button.style.display = 'none';
      return;
    }

    button.addEventListener('click', function () {
      if (loading || current >= total) return;
      loading = true;

      var next = current + 1;
      var label = button.textContent;
      button.disabled = true;
      button.textContent = 'Loading…';

      var url = baseUrl + '&page=' + next + '&section_id=' + SECTION_ID;

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Load more request failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var fetchedGrid = doc.querySelector('#product-grid');
          if (fetchedGrid) {
            // appendChild adopts each node into the live document, upgrading
            // the custom elements inside the card.
            each(Array.prototype.slice.call(fetchedGrid.children), function (node) {
              grid.appendChild(node);
            });
          }

          var fetchedRoot = doc.querySelector('[data-v2-search]');
          if (fetchedRoot) {
            var fetchedTotal = parseInt(fetchedRoot.getAttribute('data-total-pages'), 10);
            if (fetchedTotal) total = fetchedTotal;
          }

          current = next;
          root.setAttribute('data-current-page', String(current));

          loading = false;
          button.disabled = false;
          button.textContent = label;
          if (current >= total) button.style.display = 'none';
        })
        .catch(function () {
          loading = false;
          button.disabled = false;
          button.textContent = label;
        });
    });
  }

  function boot() {
    each(document.querySelectorAll('[data-v2-search]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
